import { DarkWebView } from '@/views/Dashboard/DarkWebView';

export function DarkWebPage() {
  return <DarkWebView />;
}
